var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBrainIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0067FF",
    height: "100%",
    width: "100%",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59.48 59.48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.551,31.978c-0.391,0.391-0.391,1.023,0,1.414c0.901,0.901,1.398,2.099,1.398,3.371s-0.497,2.47-1.398,3.371 c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c1.279-1.279,1.984-2.979,1.984-4.785s-0.705-3.506-1.984-4.785C35.574,31.587,34.942,31.587,34.551,31.978z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.555,22.467c-2.591,0.456-5.066-1.28-5.521-3.87c-0.645-3.675-4.16-6.131-7.836-5.496 c-0.544,0.096-0.908,0.614-0.812,1.158c0.095,0.543,0.611,0.9,1.158,0.813c2.592-0.453,5.066,1.282,5.521,3.871 c0.577,3.281,3.44,5.598,6.662,5.598c0.387,0,0.78-0.033,1.174-0.103c0.544-0.096,0.908-0.614,0.812-1.158 S48.096,22.375,47.555,22.467z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3,22.684c-0.774-1.203-1.206-3.811-1.11-5.398c0.225-3.707-1.745-7.388-4.789-8.95 c-0.587-0.302-1.115-0.454-1.581-0.588c-0.801-0.231-1.132-0.327-1.435-0.956c-1.596-3.316-3.356-3.782-6.711-3.564 c-0.312,0.006-0.732-0.46-1.163-0.92c-0.741-0.793-1.731-1.852-3.301-2.032l-0.505-0.05c-1.682,0-3.309,0.501-4.463,1.374 c-0.326,0.246-0.731,0.248-1.007,0.006c-1.371-1.203-3.438-2.094-4.858-1.308c-1.558,0.307-2.556,1.295-3.293,2.025 c-0.583,0.577-0.95,0.944-1.281,0.904c-3.347-0.215-5.114,0.249-6.711,3.564c-0.302,0.629-0.633,0.725-1.434,0.956 c-0.465,0.134-0.993,0.286-1.581,0.588c-3.044,1.563-5.013,5.243-4.789,8.95c0.096,1.588-0.336,4.195-1.11,5.398 c-1.908,2.969-1.908,7.114,0,10.082c0.295,0.458,0.727,0.991,1.227,1.609c0.892,1.102,2.386,2.945,2.335,3.789 c-0.227,3.736,2.053,8.041,5.082,9.596c0.545,0.28,0.637,0.563,0.843,1.42c0.114,0.474,0.256,1.063,0.562,1.697 c0.823,1.711,2.114,2.201,3.056,2.561c0.936,0.355,1.323,0.503,1.465,1.529c0.329,2.383,1.604,3.99,3.497,4.409 c0.317,0.069,0.644,0.104,0.975,0.104c2.132,0,4.458-1.415,5.931-3.701c0.177-0.274,0.471-0.305,0.588-0.305 s0.411,0.03,0.588,0.305c1.702,2.641,4.542,4.114,6.906,3.598c1.894-0.419,3.168-2.026,3.497-4.409 c0.142-1.026,0.529-1.174,1.465-1.529c0.942-0.359,2.233-0.85,3.057-2.561c0.305-0.634,0.447-1.224,0.561-1.697 c0.207-0.856,0.298-1.14,0.843-1.42c3.028-1.555,5.308-5.859,5.082-9.596c-0.051-0.844,1.443-2.688,2.335-3.789 c0.5-0.618,0.932-1.151,1.227-1.609C57.208,29.798,57.208,25.653,55.3,22.684z M53.617,31.684 c-0.235,0.366-0.654,0.884-1.098,1.432c-0.471,0.581-0.96,1.189-1.397,1.803c-1.209-2.887-4.062-4.921-7.382-4.921 c-3.309,0-6-2.691-6-6c0-0.553-0.448-1-1-1s-1,0.447-1,1c0,4.411,3.589,8,8,8c3.309,0,6,2.691,6,6c0,0.025,0.013,0.047,0.014,0.072 c-0.002,0.072-0.017,0.145-0.013,0.216c0.176,2.915-1.692,6.512-3.999,7.695c-0.205,0.105-0.379,0.22-0.538,0.34 c-1.054-2.534-3.554-4.322-6.465-4.322c-0.552,0-1,0.447-1,1s0.448,1,1,1c2.757,0,5,2.243,5,5c0,0.041,0.019,0.076,0.023,0.116 c-0.078,0.295-0.168,0.593-0.314,0.896c-0.478,0.992-1.134,1.242-1.965,1.559c-1.026,0.39-2.432,0.925-2.735,3.125 c-0.149,1.082-0.608,2.434-1.947,2.729c-1.539,0.341-3.555-0.807-4.793-2.729c-0.493-0.764-1.341-1.221-2.269-1.221 c-0.22,0-0.435,0.03-0.643,0.079c-0.112-0.043-0.231-0.072-0.357-0.072c-0.503,0-0.901,0.377-0.972,0.86 c-0.105,0.113-0.213,0.222-0.298,0.353c-0.187,0.291-0.397,0.557-0.615,0.81c-0.04-0.005-0.074-0.023-0.115-0.023 c-0.552,0-1,0.448-1,1c0,0.019,0.01,0.035,0.011,0.054c-0.931,0.683-1.948,1.022-2.84,0.911c0.467-0.084,0.829-0.474,0.829-0.965 c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,0.248,0.1,0.468,0.25,0.643c-0.583-0.382-0.918-1.018-1.101-1.673 c0.479-0.074,0.852-0.47,0.852-0.97c0-0.552-0.448-1-1-1c-0.118,0-0.228,0.03-0.333,0.067c-0.183-0.415-0.415-0.743-0.681-0.999 c0.002-0.024,0.014-0.044,0.014-0.068c0-0.552-0.448-1-1-1c-0.198,0-0.373,0.073-0.528,0.172c-0.073-0.028-0.147-0.058-0.216-0.084 c-0.246-0.094-0.474-0.183-0.689-0.286c0.256-0.181,0.433-0.465,0.433-0.802c0-0.552-0.448-1-1-1c-0.314,0-0.583,0.154-0.766,0.381 c-0.168-0.391-0.273-0.777-0.363-1.151c-0.228-0.945-0.487-2.018-1.874-2.729c-1.541-0.791-2.87-2.661-3.541-4.683 c0.159,0.106,0.339,0.183,0.544,0.183c0.552,0,1-0.448,1-1c0-0.552-0.448-1-1-1c-0.381,0-0.7,0.22-0.869,0.533 c-0.105-0.586-0.166-1.171-0.133-1.729c0.053-0.883-0.382-1.844-1.002-2.805c0.001,0,0.002,0.001,0.004,0.001c0.552,0,1-0.448,1-1 c0-0.552-0.448-1-1-1c-0.443,0-0.807,0.293-0.938,0.692c-0.209-0.27-0.421-0.536-0.632-0.798c0.335-0.162,0.57-0.498,0.57-0.894 c0-0.552-0.448-1-1-1c-0.311,0-0.577,0.15-0.76,0.372c-0.04-0.057-0.084-0.118-0.117-0.169c-1.499-2.33-1.499-5.587,0-7.918 c1.043-1.622,1.543-4.63,1.423-6.602c-0.175-2.893,1.383-5.857,3.706-7.05c0.4-0.205,0.795-0.321,1.177-0.432 c-0.253,0.182-0.429,0.464-0.429,0.799c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.536-0.424-0.965-0.954-0.991 c0.366-0.125,0.734-0.29,1.081-0.548c0.168,0.316,0.49,0.539,0.873,0.539c0.552,0,1-0.448,1-1c0-0.473-0.335-0.851-0.776-0.955 c0.283-0.573,0.553-1.01,0.837-1.347C15.77,6.276,15.74,6.374,15.74,6.481c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.552-0.448-1-1-1 c-0.036,0-0.067,0.017-0.102,0.021c0.386-0.191,0.839-0.284,1.397-0.312c0.181,0.18,0.43,0.291,0.705,0.291 c0.263,0,0.498-0.106,0.676-0.272c0.087,0.005,0.167,0.008,0.259,0.014c0.849,0.053,1.507-0.319,2.075-0.791 c-0.001,0.017-0.01,0.032-0.01,0.049c0,0.552,0.448,1,1,1s1-0.448,1-1c0-0.545-0.437-0.984-0.98-0.996 c0.32-0.311,0.652-0.592,1.018-0.817c0.09,0.459,0.476,0.813,0.962,0.813c0.552,0,1-0.448,1-1c0-0.179-0.06-0.339-0.143-0.484 c0.499-0.006,1.465,0.361,2.32,1.112c0.994,0.871,2.447,0.906,3.532,0.086c0.708-0.536,1.74-0.881,2.822-0.955l0.468,0.009 c0.913,0,1.482,0.538,2.311,1.425c0.714,0.763,1.532,1.607,2.753,1.55c2.792-0.177,3.625,0.036,4.78,2.436 c0.076,0.159,0.159,0.299,0.244,0.432c-2.322,0.431-4.088,2.463-4.088,4.908c0,0.553,0.448,1,1,1s1-0.447,1-1c0-1.654,1.346-3,3-3 c0.382,0,0.702-0.221,0.871-0.536c0.221,0.079,0.442,0.144,0.655,0.206c0.396,0.115,0.807,0.233,1.222,0.446 c2.322,1.192,3.881,4.157,3.706,7.05c-0.12,1.972,0.38,4.979,1.423,6.602C55.116,26.097,55.116,29.354,53.617,31.684z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 52.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 52.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.74,
    cy: 50.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 50.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 50.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 46.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 46.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 44.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.74,
    cy: 42.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 42.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 42.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 40.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 38.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 36.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 36.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 34.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 32.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.74,
    cy: 30.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 30.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 30.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 28.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.74,
    cy: 26.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 26.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 26.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 24.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.74,
    cy: 22.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 20.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 20.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 18.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 16.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 16.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.74,
    cy: 14.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 14.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 12.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 12.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 10.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.74,
    cy: 8.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.74,
    cy: 6.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.74,
    cy: 6.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.74,
    cy: 4.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.74,
    cy: 48.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.74,
    cy: 46.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 44.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 42.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.74,
    cy: 42.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 40.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 38.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 36.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.74,
    cy: 36.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.74,
    cy: 36.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 32.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.74,
    cy: 32.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.74,
    cy: 32.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 28.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.74,
    cy: 28.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.74,
    cy: 26.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 24.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 22.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.74,
    cy: 22.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.74,
    cy: 20.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.74,
    cy: 20.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 18.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.74,
    cy: 16.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 14.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.74,
    cy: 14.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.74,
    cy: 12.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.74,
    cy: 12.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.74,
    cy: 10.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.74,
    cy: 28.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.74,
    cy: 26.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.74,
    cy: 24.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.74,
    cy: 22.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.74,
    cy: 18.481,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.74,
    cy: 14.481,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrainIa);
export default __webpack_public_path__ + "static/media/icon-brain-ia.1c0829a6be85ab139b36621ef467e9fe.svg";
export { ForwardRef as ReactComponent };